<template>
	<div>
		
			<navigation msg="品牌管理" />
			<keep-alive>
			    <router-view v-if="$route.meta.keepAlive"></router-view>
			</keep-alive>
			<router-view v-if="!$route.meta.keepAlive"></router-view>
	</div>
</template>

<script>
	import navigation from '@/components/comm/navigation.vue'
	export default{
		data(){
			return {}
		},
		components:{
			navigation
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/brand/home.vue